{
  "version": 1,
  "source": "docs/references/maps/De_Groote_Kaart_van_Amsterdam_in_1544_by_Cornelis_Anthonisz.jpg",
  "notes": "Read by eye on the 1544 woodcut, which looks from the north-east. It draws the church free of houses on every side it shows. Along the south side stands one straight row of five trees, with a row of houses beyond that faces the church. Between the tower and the back of the Warmoesstraat row stands a group of three or four trees in a line, by the mouth of the Enge Kerksteeg, and the row itself is one straight line of fronts on the Warmoesstraat, a house deep. The west and south-west of the tower are hidden behind it and are left as they were. The woodcut turns the church about 25 degrees towards the viewer against its streets, so its trees cannot be placed by georeference: the template reading (woodcutTrees.json) puts three of the north-west group on the plein and the alley. Each row is therefore set beside the Oudekerksplein's centreline, on the church side. The south row is placed so that the south portal opens between two of its trees. Chainages, offsets, tree counts beyond the five and the three or four drawn, spacing, the ten fronts, their widths, depth, storeys and roofs are estimates, not a parcel survey. See docs/oudezijde-blocks.md, The yard of the Oude Kerk.",
  "trees": [
    {
      "id": "south",
      "street": "street-oudekerksplein",
      "from": 12.2,
      "to": 41.65,
      "inside": 4,
      "count": 5
    },
    {
      "id": "north-west",
      "street": "street-oudekerksplein",
      "from": 99.15,
      "to": 129.15,
      "inside": 3.5,
      "count": 4
    }
  ],
  "rows": [
    {
      "id": "oudekerk-warmoes-toren",
      "source": "street-warmoesstraat",
      "side": "right",
      "from": 237.5,
      "to": 293,
      "depth": 15,
      "evidence": "inferred",
      "note": "The woodcut draws this row past the tower as single houses about 15 m deep with their gables on the Warmoesstraat. Ten fronts of about 5.5 m is the width of the rows on either side, not a count from the woodcut.",
      "houses": [
        {
          "id": "oudekerk-warmoes-toren-01",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "oudekerk-warmoes-toren-02",
          "widthWeight": 1.05,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "oudekerk-warmoes-toren-03",
          "widthWeight": 0.95,
          "storeys": 3,
          "roof": "slate"
        },
        {
          "id": "oudekerk-warmoes-toren-04",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "oudekerk-warmoes-toren-05",
          "widthWeight": 1.1,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "oudekerk-warmoes-toren-06",
          "widthWeight": 0.9,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "oudekerk-warmoes-toren-07",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "slate"
        },
        {
          "id": "oudekerk-warmoes-toren-08",
          "widthWeight": 1.05,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "oudekerk-warmoes-toren-09",
          "widthWeight": 0.95,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "oudekerk-warmoes-toren-10",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "tile"
        }
      ]
    },
    {
      "id": "oudekerk-plein-zuid",
      "source": "street-oudekerksplein",
      "side": "left",
      "from": 10.0,
      "to": 42.0,
      "depth": 10.5,
      "evidence": "inferred",
      "note": "The 1544 woodcut shows a row of domestic gables facing the church beyond the southern trees. The 1538 painting corroborates the open church-side margin and surrounding house masses, without resolving individual plots. Seven fronts, their chainages, 10.5 m depth, storeys, roof materials and gable choices are reconstruction estimates fitted to the retained plein; they are not seven recovered properties. This church-facing relationship takes priority over the earlier estimated canal-plot rear margins.",
      "houses": [
        {
          "id": "oudekerk-plein-zuid-01",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "oudekerk-plein-zuid-02",
          "widthWeight": 1.1,
          "storeys": 2,
          "roof": "tile",
          "gable": "stepped"
        },
        {
          "id": "oudekerk-plein-zuid-03",
          "widthWeight": 0.95,
          "storeys": 3,
          "roof": "slate",
          "gable": "plain"
        },
        {
          "id": "oudekerk-plein-zuid-04",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "oudekerk-plein-zuid-05",
          "widthWeight": 1.05,
          "storeys": 3,
          "roof": "tile",
          "gable": "stepped"
        },
        {
          "id": "oudekerk-plein-zuid-06",
          "widthWeight": 0.9,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "oudekerk-plein-zuid-07",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        }
      ]
    }
  ]
}
